<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Get Student Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-radio-group
                    v-if="tenant == 'saisa' || tenant == 'desschool' || tenant == 'mkd' || tenant == 'sanjivani'"
                    v-model="printType" @change="onPrintTypeChange" row>
                    <v-radio v-if="show_exam_marksheet" label="Exam Marksheet" value="exam"></v-radio>
                    <v-radio label="Single Marksheet Print" value="single"></v-radio>
                    <v-radio label="Bulk Marksheet Print" value="bulk"></v-radio>
                </v-radio-group>
            </v-row>
            <v-row justify="center"
                v-if="(tenant != 'saisa' || tenant != 'desschool' || tenant != 'mkd' || tenant != 'sanjivani') && printType === 'single'"
                dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined persistent-hint
                        @change="onAcademicYearChange" hint="Please select academic year" @click="show = false" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" return-object label="Semester" persistent-hint
                        hint="Please select semester" @click="show = false" />
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" @click="putnull2(); putnull3()" dense rounded required
                        v-model="status" :items="status_list" item-text="name" item-value="id" label="Status" outlined
                        persistent-hint hint="Select Status" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" :items="std_list"
                        item-text="std" return-object label="Select Standard" outlined persistent-hint
                        hint="Please select standard" @change="onStandardChange" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_std_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_div_data" :items="div_list"
                        @change="getStud" item-text="div_name" return-object label="Select Division" outlined
                        persistent-hint hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete v-model="registration_no" rounded color="#0F2027" :items="stud_list"
                        label="Select Student" item-text="name" return-object @change="
                            addtomarksheet();
                        getAnnualMarksheet();
                        " outlined dense @click="show = false" persistent-hint hint="Please select Student" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="tenant == 'desschool'">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="viewType" :items="viewTypeOptions"
                        item-text="label" item-value="value" label="Select View" outlined persistent-hint
                        hint="Please select view type" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="tenant == 'desschool' || tenant == 'sbpps'">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="resultType"
                        :items="resultTypeOptions" item-text="label" item-value="value" label="Select Result Type"
                        outlined persistent-hint hint="Please select Result type" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sem && registration_no">
                    <v-btn class="mt-6 button" :loading="fecth_gen_btn_loader" @click="callSingleAPI()">Fetch / Generate
                        1</v-btn>
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sem && registration_no">
                    <v-btn class="mt-6 button" :loading="fecth_gen_btn_loader" @click="getreport1()">Fetch / Generate
                        2</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" v-if="printType === 'bulk'" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined persistent-hint
                        @change="onAcademicYearChange" hint="Please select academic year" @click="show = false" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" return-object label="Semester" persistent-hint
                        hint="Please select semester" @click="show = false" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" :items="std_list"
                        item-text="std" return-object label="Select Standard" outlined persistent-hint
                        hint="Please select standard" @change="onStandardChange" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_std_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_div_data" :items="div_list"
                        item-text="div_name" return-object label="Select Division" outlined persistent-hint
                        hint="Please select division" />
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" @click="putnull3()" dense rounded required v-model="status"
                        :items="status_list" item-text="name" item-value="id" label="Status" outlined persistent-hint
                        hint="Select Status" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="tenant == 'desschool'">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="viewType" :items="viewTypeOptions"
                        item-text="label" item-value="value" label="Select View" outlined persistent-hint
                        hint="Please select view type" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="tenant == 'desschool'">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="resultType"
                        :items="resultTypeOptions" item-text="label" item-value="value" label="Select Result Type"
                        outlined persistent-hint hint="Please select Result type" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sem && sel_std_data">
                    <v-btn class="mt-6 button" :loading="fecth_gen_btn_loader" @click="printMarksheet()">Fetch /
                        Generate
                    </v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" v-if="printType === 'exam'" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined persistent-hint
                        @change="onAcademicYearChange(); getassschemedetails()" hint="Please select academic year"
                        @click="show = false" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" return-object label="Semester" persistent-hint
                        hint="Please select semester" @click="show = false" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" :items="std_list"
                        item-text="std" return-object label="Select Standard" outlined persistent-hint
                        hint="Please select standard" @change="onStandardChange" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_std_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_div_data" :items="div_list"
                        @change="getStud" item-text="div_name" return-object label="Select Division" outlined
                        persistent-hint hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="asd"
                        :items="assessment_detail_list" item-text="assessmenttype" item-value="id" return-object
                        label="Assessment Type" persistent-hint hint="Please select Assessment Type"
                        @click="show = false" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete v-model="registration_no" rounded color="#0F2027" :items="stud_list"
                        label="Select Student" item-text="name" return-object @change="
                            addtomarksheet();
                        getAnnualMarksheet();
                        " outlined dense @click="show = false" persistent-hint hint="Please select Student" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && asd && registration_no">
                    <v-btn class="mt-6 button" :loading="fecth_gen_btn_loader" @click="getExamReport()">Fetch / Generate
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import LearnetMarksheetOfAdmin from "./LearnetMarksheetOfAdmin";
import AnnualMarksheet from "./AnnualMarksheet";
import AnnualReportSecondary from "./AnnualReportSecondary";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        "learner-marksheet-admin": LearnetMarksheetOfAdmin,
        "annual-marksheet-admin": AnnualMarksheet,
        "annual-marksheet-admin-secondary": AnnualReportSecondary,
        Breadcrumbs
    },
    data() {
        return {
            default_value: [],
            //   dialog_marks: false,
            //   extraBreadcrumbItems: [


            //   ],
            //   breadcrumbClass: "breadcrumb-style1",
            ay_std_div_list: [],
            std_list: [],
            div_list: [],
            sel_std_data: null,
            sel_div_data: null,
            overlay: false,
            selected: [],
            snackbar: false,
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            semester_list: null,
            sem: null,
            fetch_loader: false,
            show: false,
            course_list: [],
            stud_list: [],
            awspath: "",
            registration_no: null,
            standard: null,
            div: null,
            ay: null,
            asd: null,
            name: null,
            dob: null,
            roll_no: null,
            mobile_no: null,
            address: null,
            mother_name: null,
            photo: null,
            reg_no: null,
            father_full_name: null,
            leraner_marksheet: [],
            semester: null,
            colspan: null,
            overall_grade: null,
            remark: [],
            anuual_report: false,
            fecth_gen_btn_loader: false,
            status_list: [
                { name: "Active", id: "0" },
                { name: "Temporary Inactive", id: "1" },
                { name: "Permanent Inactive", id: "2" },
            ],
            status: "0",
            orgid: null,
            tenant: null,
            printType: 'single',
            viewType: null,
            viewTypeOptions: [
                { label: "Admin View", value: "admin" },
                { label: "Parent View", value: "parent" },
            ],
            resultType: null,
            resultTypeOptions: [
                { label: "Regular Result", value: "regular" },
                { label: "Re-exam", value: "reexam" },
            ],
            is_hsc: false,
            show_exam_marksheet: false,
            assessment_detail_list: []
        };
    },
    watch: {
        sem() {
            this.registration_no = null;
        },
        printType() {
            this.viewType = null;
            this.resultType = null;
        },
    },
    methods: {
        async getExamReport() {

            localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setsem", this.sem.id);
                localStorage.setItem("asd", this.asd.id);
                localStorage.setItem("setreg_no", this.registration_no.registration_number);
                localStorage.removeItem("isBulk");
                localStorage.setItem("isBulk", "false");
                localStorage.setItem("isExamWise", "true");
                localStorage.setItem("setsem_name", this.sem.name);
                localStorage.setItem("viewType", this.viewType);
                localStorage.setItem("resultType", this.resultType);
                localStorage.setItem("setreg_no", this.registration_no.registration_number);
            let routeData = this.$router.resolve({
                name: "des-template-marksheet",
            });
            window.open(routeData.href, "_blank");
        },
        getassschemedetails() {
            const data = {
                ay: this.sel_ay_data.ay_id,
            };
            axios
                .post("/WWSExamination/getassschemedetailsconfig", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.assessment_detail_list = res.data.assessment_detail_list;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.msg_flag);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        onPrintTypeChange() {
            this.sel_std_data = null
            this.sel_div_data = null
            this.registration_no = null
            this.sel_ay_data = null
            this.sem = null
            this.viewType = null;
            this.resultType = null;
        },
        onAcademicYearChange() {
            this.sel_std_data = null;
            this.sel_div_data = null;
            this.div_list = [];
            this.std_list = this.sel_ay_data.std_list || [];
            this.viewType = null;
            this.resultType = null;
        },
        onStandardChange() {
            this.sel_div_data = null;
            this.div_list = this.sel_std_data.div_list || [];
            this.registration_no = null
            this.viewType = null;
            this.resultType = null;
        },
        getStud() {
            if (!this.sel_div_data) return;

            const payload = {
                ay_id: this.sel_ay_data.ay_id,
                div_off_id: this.sel_div_data.div_off_id,
                status: this.status,
            };

            axios
                .post("/sanjivaniExamination/getStudentByStdDiv", payload)
                .then((res) => {
                    this.stud_list = res.data.stud_list || [];
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Failed to fetch students");
                });
        },
        saveremark() {
            const data = {
                lms_id: this.leraner_marksheet.lms_id,
                remark: this.remark,
            };
            axios
                .post("/Examination/saveremark", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Remark save successfully...!");
                        this.getreport();
                        this.dialog_marks = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    this.remark = [];
                });
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        putnull3() {
            this.show = false;
        },
        putnull2() {
            this.stud_list = null;
            this.sel_div_data = null;
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        addtomarksheet() {
            if (this.sem.name != "Annual") {
                //  alert(this.sem.display_name)
                const data = {
                    lid: this.registration_no.registration_number,
                    ay: this.sel_ay_data.ay_id,
                    sem: this.sem.id,
                };
                axios
                    .post("/Examination/getStudentReport", data)
                    .then((res) => { })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => { });
            }
        },
        callSingleAPI() {
            //         <span v-if="show == true && sem.display_name !='Annual'">
            //     <learner-marksheet-admin></learner-marksheet-admin>
            // </span>
            // <span v-if="show == true && sem.display_name =='Annual' && anuual_report == true">
            //     <span v-if="registration_no.standard == 'IX' || registration_no.standard == 'X'">
            //          <!-- in 9th and 10th marksheet -->
            //         <annual-marksheet-admin-secondary></annual-marksheet-admin-secondary>
            //     </span>
            //     <span v-else>
            //         <annual-marksheet-admin></annual-marksheet-admin>
            //     </span>
            // </span>
            if (this.sem.name == "Annual" && this.anuual_report == true) {
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setsem", this.sem.id);
                localStorage.setItem("setreg_no", this.registration_no.registration_number);
                localStorage.setItem("setsem_name", this.sem.name);
                localStorage.removeItem("isBulk");
                localStorage.setItem("isBulk", "false");
                this.show = true;
                if (this.tenant == 'sanjivani') {
                    if (this.orgid == 1 || this.orgid == 2 || this.orgid == 3 || this.orgid == 7) {
                        if (this.registration_no.standard == "IV"
                            || this.registration_no.standard == "V"
                            || this.registration_no.standard == "VI"
                            || this.registration_no.standard == "VII"
                            || this.registration_no.standard == "VIII") {
                            let routeData = this.$router.resolve({
                                name: "sgs-cbse-annual-marksheet",
                            });
                            window.open(routeData.href, "_blank");
                        }
                        else {
                            let routeData = this.$router.resolve({
                                name: "hpc-marksheet",
                            });
                            window.open(routeData.href, "_blank");
                        }
                    }
                }
                else if (this.tenant == 'saisa') {
                    if (this.registration_no.standard == "I"
                        || this.registration_no.standard == "II"
                        || this.registration_no.standard == "III"
                        || this.registration_no.standard == "IV"
                        || this.registration_no.standard == "V") {
                        let routeData = this.$router.resolve({
                            name: "saisa-cbse-annual-marksheet",
                        });
                        window.open(routeData.href, "_blank");
                    } else {
                        let routeData = this.$router.resolve({ name: "sbpps-ams" });
                        window.open(routeData.href, "_blank");
                    }
                }
                else if (this.tenant == 'desschool') {
                    localStorage.setItem("viewType", this.viewType);
                    localStorage.setItem("resultType", this.resultType);
                    let routeData = this.$router.resolve({
                        name: "des-template-marksheet",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (this.tenant == 'tmvidyalaya') {
                    localStorage.setItem("viewType", this.viewType);
                    localStorage.setItem("resultType", this.resultType);
                    let routeData = this.$router.resolve({
                        name: "des-template-marksheet",
                    });
                    window.open(routeData.href, "_blank");
                }
                else {
                    if (this.registration_no.standard == "IX" || this.registration_no.standard == "X") {
                        //let routeData = this.$router.resolve({name: 'annual-marksheet-admin-secondary'});
                        // if (this.sel_ay_data.ay == "2021-22") {
                        //     let routeData = this.$router.resolve({
                        //         name: "sbpps-secondary-ams",
                        //     });
                        //     window.open(routeData.href, "_blank");
                        // } else{ //if (this.sel_ay_data.ay == "2022-23" || this.sel_ay_data.ay == "2023-24" || this.sel_ay_data.ay == "2024-25") {
                        let routeData = this.$router.resolve({
                            name: "sbpps-secondary-ams-22-23",
                        });
                        window.open(routeData.href, "_blank");
                        // }
                    } else if (this.registration_no.standard == "XI (Comm)" || this.registration_no.standard == "XI (Sci)" || this.registration_no.standard == "XII (Sci)" || this.registration_no.standard == "XII (Comm)") {
                        if (this.is_hsc) {
                            let routeData = this.$router.resolve({
                                name: "des-template-marksheet",
                            });
                            window.open(routeData.href, "_blank");
                        } else {
                            let routeData = this.$router.resolve({
                                name: "sbpps-secondary-ams-xi",
                            });
                            window.open(routeData.href, "_blank");
                        }
                    } else {
                        let routeData = this.$router.resolve({ name: "sbpps-ams" });
                        window.open(routeData.href, "_blank");
                    }
                }
            } else {
                // this.$store.commit("setay", this.sel_ay_data.ay_id);
                // this.$store.commit("setsem", this.sem.id);
                // this.$store.commit("setreg_no", this.registration_no.registration_number);
                // this.show = true;
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setsem", this.sem.id);
                localStorage.setItem("setreg_no", this.registration_no.registration_number);
                localStorage.removeItem("isBulk");
                localStorage.setItem("isBulk", "false");
                localStorage.setItem("setsem_name", this.sem.name);
                this.show = true;
                localStorage.setItem("viewType", this.viewType);
                localStorage.setItem("resultType", this.resultType);
                if (this.tenant == 'desschool') {
                    let routeData = this.$router.resolve({
                        name: "des-template-marksheet",
                    });
                    window.open(routeData.href, "_blank");
                } else {
                    if (this.registration_no.standard == "XI (Comm)" || this.registration_no.standard == "XI (Sci)" || this.registration_no.standard == "XII (Sci)" || this.registration_no.standard == "XII (Comm)") {
                        let routeData = this.$router.resolve({ name: "sbpps-primary-hsc" });
                        window.open(routeData.href, "_blank");
                    } else {
                        // let routeData = this.$router.resolve({name: 'learner-marksheet-admin'});
                        let routeData = this.$router.resolve({ name: "sbpps-primary-ms" });
                        window.open(routeData.href, "_blank");
                    }
                }
            }
        },
        getreport1() {
            if (this.sem.name == "Annual" && this.anuual_report == true) {
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setsem", this.sem.id);
                localStorage.setItem("setreg_no", this.registration_no.registration_number);
                localStorage.setItem("setsem_name", this.sem.name);
                localStorage.removeItem("isBulk");
                localStorage.setItem("isBulk", "false");
                this.show = true;
                if (this.tenant == 'sanjivani') {
                    if (this.orgid == 1 || this.orgid == 2 || this.orgid == 3 || this.orgid == 7) {
                        if (this.registration_no.standard == "IV"
                            || this.registration_no.standard == "V"
                            || this.registration_no.standard == "VI"
                            || this.registration_no.standard == "VII"
                            || this.registration_no.standard == "VIII") {
                            let routeData = this.$router.resolve({
                                name: "sgs-cbse-annual-marksheet",
                            });
                            window.open(routeData.href, "_blank");
                        }
                        else {
                            let routeData = this.$router.resolve({
                                name: "hpc-marksheet",
                            });
                            window.open(routeData.href, "_blank");
                        }
                    }
                } else if (this.tenant == 'desschool') {
                    let routeData = this.$router.resolve({
                        name: "des-template-marksheet",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (this.tenant == 'saisa') {
                    if (this.registration_no.standard == "I"
                        || this.registration_no.standard == "II"
                        || this.registration_no.standard == "III"
                        || this.registration_no.standard == "IV"
                        || this.registration_no.standard == "V") {
                        let routeData = this.$router.resolve({
                            name: "saisa-cbse-annual-marksheet",
                        });
                        window.open(routeData.href, "_blank");
                    } else {
                        let routeData = this.$router.resolve({ name: "sbpps-ams" });
                        window.open(routeData.href, "_blank");
                    }

                }
                else {
                    if (this.registration_no.standard == "IX" || this.registration_no.standard == "X") {
                        //let routeData = this.$router.resolve({name: 'annual-marksheet-admin-secondary'});
                        if (this.sel_ay_data.ay == "2021-22") {
                            let routeData = this.$router.resolve({
                                name: "sbpps-secondary-ams",
                            });
                            window.open(routeData.href, "_blank");
                        } else { //if (this.sel_ay_data.ay == "2022-23" || this.sel_ay_data.ay == "2023-24" || this.sel_ay_data.ay == "2024-25") {
                            let routeData = this.$router.resolve({
                                name: "sbpps-secondary-ams-22-23",
                            });
                            window.open(routeData.href, "_blank");
                        }
                    } else if (this.registration_no.standard == "XI (Comm)" || this.registration_no.standard == "XI (Sci)" || this.registration_no.standard == "XII (Sci)" || this.registration_no.standard == "XII (Comm)") {
                        if (this.is_hsc) {
                            let routeData = this.$router.resolve({
                                name: "des-template-marksheet",
                            });
                            window.open(routeData.href, "_blank");
                        } else {
                            let routeData = this.$router.resolve({
                                name: "sbpps-secondary-ams-xi",
                            });
                            window.open(routeData.href, "_blank");
                        }
                    } else {
                        let routeData = this.$router.resolve({ name: "sbpps-ams-2" });
                        window.open(routeData.href, "_blank");
                    }
                }
            } else {
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setsem", this.sem.id);
                localStorage.setItem("setreg_no", this.registration_no.registration_number);
                localStorage.setItem("viewType", this.viewType);
                localStorage.setItem("resultType", this.resultType);
                localStorage.setItem("setsem_name", this.sem.name);
                this.show = true;
                if (this.tenant == 'desschool') {
                    let routeData = this.$router.resolve({
                        name: "des-template-marksheet",
                    });
                    window.open(routeData.href, "_blank");
                }
                else {
                    if (this.registration_no.standard == "XI (Comm)" || this.registration_no.standard == "XI (Sci)" || this.registration_no.standard == "XII (Sci)" || this.registration_no.standard == "XII (Comm)") {
                        let routeData = this.$router.resolve({ name: "sbpps-primary-hsc" });
                        window.open(routeData.href, "_blank");
                    } else {
                        // let routeData = this.$router.resolve({name: 'learner-marksheet-admin'});
                        let routeData = this.$router.resolve({ name: "sbpps-primary-ms" });
                        window.open(routeData.href, "_blank");
                    }
                }
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getAnnualMarksheet() {
            if (this.sem.name == "Annual") {
                const data = {
                    lid: this.registration_no.registration_number,
                    ay: this.sel_ay_data.ay_id,
                    sem: this.sem.id,
                };
                this.fecth_gen_btn_loader = true;
                axios
                    .post("/Examination/checkAnnualMarksheet", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.flag == "No") {
                                this.showSnackbar("#b71c1c", "Please generate both semester marksheet...");
                                this.anuual_report = false;
                            }
                            if (res.data.flag == "Yes") {
                                this.anuual_report = true;
                                this.registration_no.standard = res.data.check_standard;
                            }
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                        this.fecth_gen_btn_loader = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.fecth_gen_btn_loader = false;
                    })
                    .finally(() => {
                        this.comp_load = false;
                        this.fecth_gen_btn_loader = false;
                    });
            }
        },
        //   getStud() {

        //     const data = {
        //         ay:this.sel_ay_data.ay_id,
        //         status: this.status,
        //       };
        //       axios
        //           .post("/admission/getAllStudents_statuswise",data)
        //           .then((res) => {
        //               if (res.data.msg == "200") {
        //                   this.stud_list = res.data.stud_list;
        //               } else {
        //                   this.showSnackbar("#b71c1c", "Something went wrong...");
        //               }
        //           })
        //           .catch((error) => {
        //               this.showSnackbar("#b71c1c", "Something went wrong...");
        //           })
        //           .finally(() => {
        //               this.comp_load = false;
        //           });
        //   },
        onload() {
            this.overlay = true;
            this.role = sessionStorage.getItem("para_role");
            const data = {
                role: this.role,
            };
            axios
                .post("/commonAPI/get_ay_std_div_wws_by_access", data)
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    this.is_hsc = res.data.is_hsc;
                    this.show_exam_marksheet = res.data.show_exam_marksheet;
                    //     this.sel_ay_data = res.data.curr_ay;
                    //  this.semester_list = ["Annual"];
                    // this.sem = "Annual";
                    this.semester_list = res.data.sem_list;
                    //   alert(JSON.stringify(this.semester_list))
                    // this.semester_list.unshift("Annual");
                    this.overlay = false;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        printMarksheet() {
            if (this.printType === "single") {
                this.callSingleAPI();
            } else {
                this.callBulkAPI();
            }
        },
        callBulkAPI() {
            localStorage.setItem("setay", this.sel_ay_data.ay_id);
            localStorage.setItem("setsem", this.sem.id);
            localStorage.setItem("status", this.status);
            localStorage.setItem("setstd", this.sel_std_data.std_id);
            localStorage.setItem("setdiv", this.sel_div_data.div_off_id);
            localStorage.setItem("isBulk", "true");
            localStorage.setItem("setsem_name", this.sem.name);
            console.log("isBulk set:", localStorage.getItem("isBulk"));

            if (this.tenant == 'desschool') {
                localStorage.setItem("viewType", this.viewType);
                localStorage.setItem("resultType", this.resultType);
                let routeData = this.$router.resolve({
                    name: "des-template-marksheet",
                });
                window.open(routeData.href, "_blank");
            }
            else if (this.tenant == 'saisa') {
                if (this.sel_std_data.std == "I"
                    || this.sel_std_data.std == "II"
                    || this.sel_std_data.std == "III"
                    || this.sel_std_data.std == "IV"
                    || this.sel_std_data.std == "V") {
                    let routeData = this.$router.resolve({
                        name: "saisa-cbse-annual-marksheet",
                    });
                    window.open(routeData.href, "_blank");
                } else {
                    let routeData = this.$router.resolve({ name: "sbpps-ams" });
                    window.open(routeData.href, "_blank");
                }

            }
            else if (this.tenant == 'mkd') {
                if (this.sem.name === 'Term - I' || this.sem.name === "Term - II") {
                    let routeData = this.$router.resolve({ name: "bulk-learner-marksheet" });
                    window.open(routeData.href, "_blank");
                } else {
                    let routeData = this.$router.resolve({ name: "sbpps-ams" });
                    window.open(routeData.href, "_blank");
                }
            }
            else if (this.tenant == 'sanjivani') {
                if (this.orgid == 1 || this.orgid == 2 || this.orgid == 3 || this.orgid == 7) {
                    if (this.sel_std_data.std == "IV"
                        || this.sel_std_data.std == "V"
                        || this.sel_std_data.std == "VI"
                        || this.sel_std_data.std == "VII"
                        || this.sel_std_data.std == "VIII") {
                        let routeData = this.$router.resolve({
                            name: "sgs-cbse-annual-marksheet",
                        });
                        window.open(routeData.href, "_blank");
                    }
                    else {
                        let routeData = this.$router.resolve({
                            name: "hpc-marksheet",
                        });
                        window.open(routeData.href, "_blank");
                    }
                }
            }
        }
    },
    mounted() {
        this.onload();
        this.orgid = localStorage.getItem("EPS-org-id");
        this.awspath = localStorage.getItem("awspath");
        this.tenant = localStorage.getItem("EPS-tenant");
    },
};
</script>
<style scoped>
.text_report {
    border: 3px solid black;
    margin: 1rem !important;
}

thead {
    font-weight: bold !important;
}

th {
    font-weight: bold !important;
}

tr,
td,
th {
    border: 1px solid black;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid black;
    border: 1px solid black;
    font-size: small;
}

td {
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}

.radiospace {
    margin: 1rem !important;
    padding: 0%;
}

.btn-css {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #fff !important;
    text-decoration: underline;
    color: #0f2027 !important;
    text-align: left;
}

.btn-css:hover {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #ffff !important;
    color: #0f2027 !important;
    text-decoration: underline;
    text-align: left;
}

.t-row {
    padding: 1rem i !important;
}

.mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.delete-avatar {
    transition: 0.3s;
    border: 1px solid red;
    margin: 0.2rem !important;
}

.delete-avatar:hover {
    background-color: transparent;
}

.delete-v-icon {
    padding-left: 8px;
    padding-top: 1px;
    font-size: 15px;
}

.delete-v-icon:hover {
    color: white;
}

.v-dialogss {
    bottom: 880;
    right: 0;
}

@media print {
    .card {
        border: none !important;
        font-size: large !important;
    }

    .pagebreak {
        page-break-before: always;
    }

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
    }

    img {
        width: 100% !important;
    }

    body,
    tr,
    th,
    td {
        font-size: large !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    v-card {
        border: none !important;
    }

    @page {
        size: A4;
        margin-top: none;
        padding-top: none;
        size: 15.5in 15.5in;
    }

    thead {
        font-weight: bold !important;
    }

    table,
    td,
    tr,
    th {
        text-align: center !important;
        margin-top: none;
        padding: none !important;
        border-bottom: 1px solid black;
        border: 1px solid black;
    }
}

ol.s {
    list-style-type: inherit;
}
</style>